import React from 'react';

import FormSelect from "../../../gd-form/form-element/select-new/select-new";
import FormManager from "../../../gd-form/common/form-manager";
import FormRow from "../../../gd-form/form/form-ui5/form-row";
import FormError from "../../../gd-form/common/form-error/form-error";
import {CustomFieldAccessOptions} from "../../../model2/custom-field/@const";

type Props = {
    form        : FormManager
}

export default function CustomField_FormRowAccess(props:Props) {

    return (
        <FormRow label="Display to">
            <FormSelect form={props.form} name="fieldAccess" options={CustomFieldAccessOptions} placeholder="Please select" />
            <FormError form={props.form} name="fieldAccess"/>
        </FormRow>
    )
}
